import { findLesson } from "./_helpers";
import { LessonShell } from "@/components/LessonShell";
import { RomanNumeralAnalysis } from "@/components/song/RomanNumeralAnalysis";
import { YouTubeEmbed } from "@/components/song/YouTubeEmbed";
import { NoteImage } from "@/components/mt/NoteImage";
import { Section } from "@/components/Section";
import { KeyIdea, DidYouKnow } from "@/components/Callouts";

export default function EdSheeran3() {
  const { lesson, course, accent } = findLesson("ed-sheeran", "3");
  return (
    <LessonShell
      course={course}
      courseSlug="ed-sheeran"
      lessonOrder={lesson.order}
      title={lesson.title}
      description={lesson.desc}
      videoUrl={lesson.video}
      thumbUrl={lesson.thumb}
      accent={accent}
    >
      <Section title="Chord Chart">
        <NoteImage
          src="/notes/ed-sheeran/finals/03-azizam.png"
          caption="Jason's chord chart for Azizam"
        />
      </Section>

      <Section title="Harmony">
        <RomanNumeralAnalysis
          label="Main · E♭ minor"
          chords={[
            { chord: "Ebm", rn: "i", function: "Tonic", pitches: ["Eb3", "Gb3", "Bb3", "Eb4"] },
            { chord: "Db", rn: "♭VII", pitches: ["Db3", "F3", "Ab3", "Db4"] },
            { bar: true },
            { chord: "Bbm", rn: "v", function: "Dominant", pitches: ["Bb2", "Db3", "F3", "Bb3"] },
            { chord: "B", rn: "♭VI", function: "Submediant", pitches: ["B2", "D#3", "F#3", "B3"] },
          ]}
        />
        <KeyIdea title="Special moment">
          All four chords come from E♭ natural minor (E♭ F G♭ A♭ B♭ C♭ D♭). Jason writes the
          last chord as B — in E♭ minor it is ♭VI, C♭ major, the same keys on the piano as
          B–D♯–F♯. The roots fall E♭ → D♭ → B♭, then lift a half step to B.
        </KeyIdea>
      </Section>

      <Section title="Context">
        <DidYouKnow title="About the song">
          Azizam is Persian (Farsi) for "my dear". It was the first single from Play, and its
          co-writer and producer, Ilya Salmanzadeh, is Swedish-Iranian.
        </DidYouKnow>
        <YouTubeEmbed videoId="MI9ZpIKgyf0" />
      </Section>
    </LessonShell>
  );
}
